import React, { useState, useEffect } from "react";
import axios from "axios";

function UserProfile({ loggedInUserId }) {
    const [userData, setUserData] = useState({});
    const [paymentData, setPaymentData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!loggedInUserId) return;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(
                    `/paymetsdetails/${loggedInUserId}`
                );

                if (response.status === 200) {
                    console.log("response", response)
                    setPaymentData(response.data.result2 || []);
                    setUserData(response.data.result1?.[0] || {});
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [loggedInUserId]);

    const handleCancelSubscription = async () => {
        try {
            const confirmCancel = window.confirm(
                "Are you sure you want to cancel your subscription?"
            );
            if (!confirmCancel) return;

            const response = await axios.post(`/cancel-subscription`, { loggedInUserId });
            if (response.status === 200) {
                alert("Subscription cancelled successfully");

            }

            // Optional: refresh profile data
        } catch (error) {
            console.error("Cancel subscription failed", error);
            alert("Failed to cancel subscription");
        }
    };

    if (loading) {
        return <div className="text-center mt-4">Loading profile...</div>;
    }

    return (
        <div className="container mt-4">
            <div className="row">
                {/* LEFT: USER PROFILE */}
                <div className="col-md-4">
                    <div className="card shadow-sm mb-4">
                        <div className="card-header bg-primary text-white">
                            <h5 className="mb-0">User Profile</h5>
                        </div>
                        <div className="card-body">
                            <p><strong>Name:</strong> {userData.firstname} {userData.lastname}</p>
                            <p><strong>Company:</strong> {userData.company}</p>
                            <p><strong>Email:</strong> {userData.email}</p>
                            <p><strong>Contact:</strong> {userData.phone}</p>
                            <p>
                                <strong>Plan:</strong>{" "}
                                <span>
                                    {userData.plan}
                                    {userData.plan === "Premium" && (
                                        <i
                                            className="bi bi-x-circle"
                                            role="button"
                                            title="Cancel Subscription"
                                            onClick={handleCancelSubscription}
                                            style={{ cursor: "pointer", fontSize: "14px", marginLeft: "4px" }}
                                        />
                                    )}
                                </span>
                            </p>
                            {userData.billingcycle != null && (
                                <p>
                                    <strong>Billing Cycle:</strong>{" "}
                                    {userData.billingcycle === 1 ? "Monthly" : "Annual"}
                                </p>
                            )}


                            {/* <button
                                className="btn btn-danger w-100 mt-3"
                                onClick={handleCancelSubscription}
                                disabled={!userData.plan}
                            >
                                Cancel Subscription
                            </button> */}
                        </div>
                    </div>
                </div>

                {/* RIGHT: PAYMENT DETAILS */}
                <div className="col-md-8">
                    <div className="card shadow-sm">
                        <div className="card-header bg-primary text-white">
                            <h5 className="mb-0">Payment History</h5>
                        </div>
                        <div className="card-body">
                            {paymentData.length === 0 ? (
                                <p className="text-muted text-center">
                                    No payment records found.
                                </p>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>ID</th>
                                                <th>Amount</th>
                                                <th>Payment Mode</th>
                                                <th>Credits</th>
                                                <th>Date</th>
                                                {/* <th>Status</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paymentData.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>₹ {item.amount}</td>
                                                    <td>{item.paymentmode}</td>
                                                    <td>{item.noofcredits}</td>
                                                    <td>
                                                        {new Date(item.createddate).toLocaleDateString()}
                                                    </td>
                                                    {/* <td>
                                                        <span
                                                            className={`badge ${
                                                                item.isactive
                                                                    ? "bg-success"
                                                                    : "bg-secondary"
                                                            }`}
                                                        >
                                                            {item.isactive ? "Active" : "Inactive"}
                                                        </span>
                                                    </td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserProfile;
